<div class="div-center">
    <div class="alert alert-danger" role="alert">
        <h1>ERROR 404</h1>
        <h2>¡Ups! Página no encontrada :(</h2>
        <br/>
        <button type="button" class="btn btn-danger" (click)="gotoHome()">
        Ir a página de inicio
      </button>
    </div>
</div>
